import { Text, Tooltip, TriggerText } from '@zillow/constellation-10';

const bodyText =
  'Comps, short for “comparables,” are properties that share similar basic traits, like number of bedrooms or square footage, with your property. If you’ve used the filters to select traits that are the same as your property’s, the data shown for “Your comps” is for the listings that share those traits.';

type CompsToolTipPopperProps = {
  triggerText?: string;
};

const CompsToolTip = ({ triggerText }: CompsToolTipPopperProps) => (
  <Tooltip
    content={bodyText}
    trigger={
      <TriggerText>
        <Text textStyle="body-sm" color="text.subtle">
          {triggerText || 'Your comps'}
        </Text>
      </TriggerText>
    }
  />
);

export default CompsToolTip;
